export type ThemeOption = 'default' | 'dark'

export function isValidTheme(theme: string | undefined): theme is ThemeOption {
  const validThemeOptions = ['default', 'dark']
  return !!(theme && validThemeOptions.includes(theme))
}
